// extracted by mini-css-extract-plugin
module.exports = {"content":"CalculatorDropdown_content__3S2nO","main":"CalculatorDropdown_main__25X7A","sub":"CalculatorDropdown_sub__1aY8L","menu":"CalculatorDropdown_menu__1hzHe"};